<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-27 15:52:21
 * @LastEditors: shenlin
 * @LastEditTime: 2021-11-10 16:22:26
-->
<template>
  <div class="app-container">
    <div class="app-title">
      新建企业消息推送
    </div>
    <div class="header">
      <div class="header-serach">
        <el-form :inline="true" :model="ruleform">
          <el-form-item label="">
            <el-input
              v-model="ruleform.keyWord"
              placeholder="搜索企业名称/统代/法人/注册地址"
              @keyup.enter.native="getSearch"
              clearable
              @clear="getSearch"
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item label="企业标签">
            <el-cascader
              v-model="ruleform.code"
              :options="AllDictLabel"
              :props="{ label: 'name', value: 'id' }"
              @change="getPoss"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="行业标签">
            <el-select
              v-model="ruleform.industryName"
              placeholder="请选择行业标签"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in IndustryList"
                :key="item.code"
                :label="item.industryname"
                :value="item.industryname"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在区域">
            <el-select
              v-model="ruleform.town"
              placeholder="请选择所在区域"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in areaList"
                :key="item.code"
                :label="item.county"
                :value="item.county"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <!-- <el-button
        type="primary"
        class="addPru"
        @click="exportList"
        :loading="exportLoading"
        >{{ exportName }}</el-button
      > -->
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      ref="multipleTable"
      @row-click="giveLable"
      @selection-change="handleSelectionChange"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column
        prop="entName"
        label="企业名称"
        width="320"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="creditCode"
        label="统一社会信用代码"
        align="center"
      ></el-table-column>
      <el-table-column prop="address" label="所属区域" align="center">
        <template slot-scope="scope">
          <div>
            {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.county }}
            {{ scope.row.town }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="frName"
        label="法人"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span
            style="
              color: #1890ff;
              cursor: pointer;
              margin-right: 10px;
              margin-left: -10px;
            "
            @click="enterprise(scope.row)"
            >联系企业</span
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <div class="choice">
        已选中{{ entNumber }}条数据
        <div @click="enterprise()">联系企业</div>
      </div>
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="联系企业"
      :visible.sync="dialogVisible"
      width="35%"
      @closed="handleClose"
    >
      <div>
        <div>
          <div :class="[open ? 'textshow' : 'texthide']" style="width: 90%">
            接收企业：{{ entNames.join(',') }}
            <span v-if="open" @click="open = false">
              <i class="el-icon-arrow-up"></i>
              收起
            </span>
          </div>
          <span v-if="!open" @click="open = true">
            <i class="el-icon-arrow-down"></i>
            更多
          </span>
        </div>
        <el-form
          :model="message"
          ref="message"
          label-width="100px"
          label-position="left"
          :rules="rules"
        >
          <el-form-item label="接收人" prop="recipients">
            <el-checkbox-group
              v-model="message.recipients"
              @change="onGetEntName"
            >
              <el-checkbox label="法人"></el-checkbox>
              <el-checkbox label="经办人"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div
            v-if="noContactEnt.length"
            style="font-size:14px;margin-bottom:20px"
          >
            {{ noContactEnt.join(',') }}，暂无联系人
          </div>
          <el-form-item label="发送人昵称" prop="createBy">
            <el-input
              v-model="message.createBy"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="推送渠道" prop="smsTypes">
            <el-checkbox-group v-model="message.smsTypes">
              <el-checkbox label="0">手机短信</el-checkbox>
              <el-checkbox label="1">微信公众号</el-checkbox>
              <el-checkbox label="2">站内消息</el-checkbox>
              <!-- <el-checkbox label="3">浙政钉</el-checkbox> -->
              <!-- <el-checkbox label="4">浙里办</el-checkbox> -->
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="消息内容" prop="content">
            <el-input
              type="textarea"
              v-model="message.content"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sendMovenSMS('message')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listEnt,
  exportEntList,
  getArea,
  getIndustry,
  getAllDictLabel,
  sendMovenSMS,
  insertEntMarking,
  isConnectList,
  getEntLabel
} from '@api/corporateInteraction/enterprise'
import { addMovenSMS } from '@api/video/video'
import { noBlank } from '@utils'
export default {
  data() {
    return {
      open: false,
      dialogVisible: false,
      entNumber: 0, // 选中企业数据
      areaList: [],
      IndustryList: [], // 获取行业列表
      AllDictLabel: [], // 获取所有标签
      ruleform: {
        keyWord: '', // 搜索词
        code: '', // 企业标签
        industryName: '', // 行业名称
        town: '' // 区域
      },
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      totalRecord: 0,
      message: {
        createBy: '', // 发送人昵称
        content: '', // 消息内容
        creditCodes: [], // 接受企业
        smsTypes: [], // 推送渠道
        recipients: [], // 接收人
        smsSubject: 1
      },
      entNames: [],
      noBlank,
      rules: {
        createBy: [
          { required: true, message: '请输入发送人昵称', trigger: 'blur' },
          noBlank()
        ],
        content: [
          { required: true, message: '请输入消息内容', trigger: 'blur' },
          noBlank(),
          { min: 5, message: '请输入至少五个字符', trigger: 'blur' }
        ],
        smsTypes: [
          { required: true, message: '请选择推送渠道', trigger: 'change' }
        ],
        recipients: [
          { required: true, message: '请选择接收人', trigger: 'change' }
        ]
      },
      labName: [],
      labCreditCode: '',
      labelIdList: [],
      exportName: '导出列表',
      exportLoading: false,
      noContactEnt: []
    }
  },
  watch: {
    ruleform: {
      handler(val) {
        // console.log(val)
      },
      deep: true
    }
  },
  computed: {},
  created() {
    this.getArea()
    this.getIndustry()
    this.getAllDictLabel()
  },
  mounted() {
    this.listEnt()
    // this.$refs["form"].resetFields();
  },
  methods: {
    labShow() {
      this.labName = [...this.labelIdList]
    },
    getlabel(id) {
      let arr = this.labName.map(item => {
        return item[item.length - 1]
      })
      let params = {
        codes: String(arr),
        creditCode: this.labCreditCode
      }
      // console.log(params)
      insertEntMarking(params).then(res => {
        if (res.data.code == '0000') {
          this.$refs[`popover-${id}`].showPopper = false
          this.$message.success('添加标签成功')
        } else {
          this.$message.error(res.data.msg)
        }
      })
      // console.log(this.labName)
    },
    giveLable(val) {
      // this.labelIdList = val.labelNames
      this.labCreditCode = val.creditCode
      // this.labName = [...this.labelIdList]
      getEntLabel({ creditCode: this.labCreditCode }).then(res => {
        if (res.data.code == '0000') {
          this.labelIdList = res.data.data.labelIdList
          this.labName = [...this.labelIdList]
        } else {
          this.$message.error(res.data.msg)
        }
      })
      // console.log(this.labName)
    },
    /** 获取所有标签 */
    getAllDictLabel() {
      getAllDictLabel({}).then(res => {
        if (res.data.code == '0000') {
          this.AllDictLabel = res.data.data || []
        }
      })
    },
    /** 获取丽水市以及各个区县 */
    getArea() {
      getArea({}).then(res => {
        if (res.data.code == '0000') {
          this.areaList = res.data.data || []
        }
      })
    },
    /** 获取行业数据 */
    getIndustry() {
      getIndustry({}).then(res => {
        if (res.data.code == '0000') {
          this.IndustryList = res.data.data || []
        }
      })
    },
    // 企业名称
    getSearch() {
      this.pageNum = 1
      this.listEnt()
    },
    // 所有类别
    getPoss() {
      this.pageNum = 1
      this.listEnt()
    },
    //  表格翻页
    handleCurrentChange(pageNum, e) {
      this.pageNum = pageNum
      this.listEnt()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listEnt()
    },
    // 导出列表
    exportList() {
      this.exportName = '导出中'
      this.exportLoading = true
      let params = { ...this.ruleform }
      if (params.code) {
        params.code = params.code[params.code.length - 1]
      }
      // console.log(exportEntList(params, this.downCallBack))
      exportEntList(params, this.downCallBack)
      // exportEntList(params)
    },
    downCallBack(name) {
      this.exportName = '导出列表'
      this.exportLoading = false
      this.$message.success(name)
    },
    // 列表
    listEnt() {
      let par = { ...this.ruleform }
      par.pageNum = this.pageNum
      par.pageSize = this.pageSize
      if (par.code) {
        par.code = par.code[par.code.length - 1]
      }
      listEnt(par).then(res => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData = list.results || []
          this.totalRecord = list.totalRecord || 0
        }
      })
    },
    /**
     * @name:当选择项发生变化时会触发该事件
     * @test: test font
     * @msg:
     * @param {*}
     * @return {*}
     */
    handleSelectionChange(val) {
      this.entNumber = val.length
      // console.log(val)
    },
    // 联系企业
    enterprise(val) {
      if (val) {
        this.entNames.push(val.entName)
        this.message.creditCodes.push(val.creditCode)
      } else {
        const list = this.$refs.multipleTable.selection
        if (!list.length) {
          this.$message('请选择要联系的企业')
          return false
        } else {
          list.forEach(ele => {
            this.entNames.push(ele.entName)
            this.message.creditCodes.push(ele.creditCode)
          })
        }
      }

      this.dialogVisible = true
    },
    sendMovenSMS(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = this.message
          addMovenSMS(data).then(res => {
            if (res.data.code == '0000') {
              this.$message.success('新建成功！请等待审核')
              this.$router.go(-1)
              this.dialogVisible = false
            } else {
              this.$message.error(res.data.msg)
              this.dialogVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 企业详情
    deleteEntTrain(creditCode) {
      this.$router.push({
        name: 'entDetail',
        query: { creditCode: creditCode }
      })
    },
    /** 关闭联系企业清空弹窗 */
    handleClose() {
      this.entNames = []
      this.$refs['message'].resetFields()
    },
    /** 勾选获取企业有无相关联系人 */
    onGetEntName(val) {
      // console.log(this.entNames, val)
      let par = {
        entNames: this.entNames.join(','),
        recipients: val.join(',')
      }
      isConnectList(par).then(res => {
        if (res.data.code == '0000') {
          this.noContactEnt = res.data.data || []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
  .el-dialog__body {
    height: 500px;
    overflow: auto;
    padding: 30px 60px 20px;
    font-size: 16px;
    & > div {
      & > div {
        margin-bottom: 20px;
        .texthide {
          width: auto;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap;
        }
        .textshow {
          span {
            width: auto;
          }
        }
        &:nth-child(1) {
          display: flex;
          > span {
            display: inline-block;
          }
          span {
            font-size: 14px;
            color: #1890ff;
          }
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
  }
}
.app-title {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f1f1f1;
  font-size: 16px;
}
.header {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  .header-serach {
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
  }
  .addPru {
    height: 36px;
  }
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  // display: flex;
  // justify-content: space-between;
  text-align: right;
  margin-top: 24px;
  margin-bottom: 20px;
  .choice {
    font-size: 14px;
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.6);
    > div {
      cursor: pointer;
      padding: 10px;
      border: 1px solid;
      border-radius: 4px;
      margin-left: 15px;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
</style>
